export default __webpack_public_path__ + "static/media/oe_5.101aead8.mp3";